import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Login = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Login' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M9,15 L9,22 L22,22 L22,2 L9,2 L9,9 M18,12 L0,12 M13,7 L18,12 L13,17' />
  </StyledIcon>
);
